<template>
  <div class="dyScan" v-show="show">
    <div v-show="!showConfirm && !info && qr_img" @click="close" class="mask">
      <div class="msg">
        <div class="title">抖音APP扫码发布</div>
        <div class="content">
          <img :src="qr_img" alt="">
        </div>
      </div>
    </div>
    <!-- <div v-show="!showConfirm && info" class="mask">
      <div class="confirm">
        <div class="t">
          <div class="l"></div>
          <div class="r">
            <span>{{ info }}</span>
          </div>
        </div>
        <div class="btns">
          <div @click="info = ''" class="btn g">确定</div>
        </div>
      </div>
    </div> -->
    <div v-show="showConfirm" class="mask">
      <div class="confirm">
        <div class="t">
          <div class="l"></div>
          <div class="r">
            <span>推送完成前，请不要关闭此验证窗口</span>
            <span>请在完成推送后，依实际情况点击以下按钮</span>
          </div>
        </div>
        <div class="btns">
          <div @click="confirm" class="btn g">完成推送</div>
          <div @click="close" class="btn">暂不推送</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";

export default {
  name: "dy",
  data() {
    return {
      show: true,
      msg: "",
      callback: null,
      showConfirm: false,
      qr_img: '',
      info: ''
      // time: 3000,
      // countDown: null
    };
  },
  methods: {
    getdypushurl(id) {
      let info = {
        id: id
      }
      common.myFetch(apis.getdypushurl, info).then(r => {
          if (r) {
              console.log(r);
              this.qr_img = r.qr_img
              if(r.info){
                this.info = r.info
                this.$MediaPlatformNotifyAuth({
                    title: '温馨提示',
                    msg: r.info,
                    btn1: '确定',
                    btn2: '',
                    showIcon: false
                }).then(res => {
                  this.info = ''
                  // console.log(res)
                })
              }else{
                this.info = ''
              }
          }else{
            this.close()
          }
      });
    },
    statusChange(e) {
      console.log(e)
      let content = JSON.parse(e.content)
      if(content.message == 'url-success'){
        this.showConfirm = true
      }
    },
    open(m,c) {
      this.showConfirm = false
      common.handleSocket(this.statusChange, "new_media_push_dy");
      this.getdypushurl(m)
      this.msg = m;
      this.callback = c;
      // this.time = t || this.time
      this.show = true;
      // this.countDown = setTimeout(() => {
      //   this.close()
      // }, this.time)
    },
    confirm() {
      this.show = false;
      this.callback(true)
    },
    close() {
      this.show = false;
      this.callback(false)
    }
  }
};
</script>

<style lang="less" scoped>
.dyScan {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 99999;

  .mask {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(50,59,75,0.3);
  }

  .msg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 326px;
    height: 326px;
    background: #FFFFFF;
    box-shadow: 6px 6px 20px 0px rgba(0,0,0,0.1);
    border-radius: 8px;
    padding: 40px 30px;
    box-sizing: border-box;

    .title {
      position: relative;
      width: 266px;
      padding-bottom: 11px;
      border-bottom: 1px solid #E6E6E6;
      box-sizing: border-box;
      text-align: center;
      font-size: 18px;
      line-height: 25px;
      color: #41B48C;
      font-weight: bold;

      &:after {
        position: absolute;
        left: 50%;
        bottom: -1px;
        margin-left: -90px;
        display: block;
        content: '';
        width: 180px;
        height: 2px;
        background: #41B48C;
      }
    }

    .content {
      width: 180px;
      height: 180px;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .confirm {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 472px;
    height: 170px;
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15);
    border-radius: 4px;
    padding: 30px 32px 24px;
    box-sizing: border-box;

    .t {
      display: flex;
      flex-direction: row;

      .l {
        display: block;
        width: 22px;
        height: 22px;
        background: url('./alert.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-right: 16px;
      }

      .r {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        line-height: 28px;
        color: #323B4B;
        font-weight: bold;
      }
    }

    .btns {
      display: flex;
      justify-content: flex-end;

      .btn {
        width: 80px;
        height: 32px;
        background: #B9C3C3;
        font-size: 14px;
        line-height: 32px;
        color: #FFF;
        font-weight: bold;
        user-select: none;
        cursor: pointer;
        border-radius: 4px;
        text-align: center;

        &.g {
          background: #41B48C;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
